export enum ScatterChartType {
	Histogram = 1,
	TwoD = 2,
	ThreeD = 3,
}